import React, { useState, useEffect } from "react";
import * as Service from "../../store/service";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";

const ValidateResetPasswordRequest = (props: any) => {
    const query = new URLSearchParams(props.location.search);
    const [isLinkValid, setisLinkValid] = useState(true);
    const guid = query.get("key") || query.get("KEY") || query.get("Key");
    const dispatch = useDispatch();
    let history = useHistory();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        let host = window.location.hostname;
        if (host === "localhost") {
            host = "localhost:44360";
        }

        Service.validateResetPasswordURI(guid!, host!).then((data) => {
            if (data != null) {
                let redirectURL = "/security-question-answer";
                if (data.forcePasswordUpdate == true) {
                    redirectURL = "/reset-password";
                }
                if (data.username != null && data.username != "") {
                    dispatch({ type: "SUBMIT_EMAIL", email: data.username });
                    history.push(redirectURL);
                } else if (data.email != null && data.email != "") {
                    dispatch({ type: "SUBMIT_EMAIL", email: data.email });
                    history.push(redirectURL);
                } else {
                    setisLinkValid(false);
                }
            } else {
                setisLinkValid(false);
            }
        });
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <>
            {isLinkValid ? (
                <div className="box-content loading"></div>
            ) : (
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                Reset Password
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className="box box-has-shadow box-xs offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">Forgot Your Password?</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>This link is either used or expired. Please try again or contact us if you need assistance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ValidateResetPasswordRequest;
